function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.744 16.709C24.848 19.172 9.465 30.416 9.465 30.416h3.889v24.396h28.779V30.416h3.888S30.64 19.172 27.744 16.709z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.687 36.984s1.502-2.806 5.139-2.793c3.636.014 4.973 2.793 4.973 2.793v17.829H22.687z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.69 37.395l9.676-6v23.371H3.69zM42.19 31.395l9.676 6v17.371H42.19z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.487 41.209s.64-1.197 2.192-1.191c1.551.006 2.12 1.191 2.12 1.191v7.605H6.488zM44.987 41.209s.64-1.197 2.192-1.191c1.551.006 2.12 1.191 2.12 1.191v7.605h-4.312z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 25,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.8 2v15M22.8 7h10"
}));

var SvgChurch = function SvgChurch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChurch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Church.c9fbfeb7.svg";
export { ForwardRef as ReactComponent };